import createIcon from '../../createIcon';

/**
 * @component @name PanoramaVerticalSelect
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuOTM1MSAyMS4xMkMxOC44MzUxIDE4LjE4IDE4LjI5NTEgMTUuMDkgMTguMjk1MSAxMkMxOC4yOTUxIDguOTEgMTguODQ1MSA1LjgyIDE5LjkzNTEgMi44OEMxOS45ODUxIDIuNzcgMjAuMDA1MSAyLjY2IDIwLjAwNTEgMi41N0MyMC4wMDUxIDIuMjMgMTkuNzY1MSAyIDE5LjM2NTEgMkg0LjYyNTEyQzQuMjI1MTIgMiAzLjk5NTEyIDIuMjMgMy45OTUxMiAyLjU3QzMuOTk1MTIgMi42NyA0LjAxNTEyIDIuNzcgNC4wNTUxMiAyLjg4QzUuMTY1MTIgNS44MiA1LjcwNTEyIDguOTEgNS43MDUxMiAxMkM1LjcwNTEyIDE1LjA5IDUuMTU1MTIgMTguMTggNC4wNjUxMiAyMS4xMkM0LjAxNTEyIDIxLjIzIDMuOTk1MTIgMjEuMzQgMy45OTUxMiAyMS40M0MzLjk5NTEyIDIxLjc2IDQuMjI1MTIgMjIgNC42MjUxMiAyMkgxOS4zNzUxQzE5Ljc2NTEgMjIgMjAuMDA1MSAyMS43NiAyMC4wMDUxIDIxLjQzQzIwLjAwNTEgMjEuMzMgMTkuOTg1MSAyMS4yMyAxOS45MzUxIDIxLjEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PanoramaVerticalSelect = createIcon('PanoramaVerticalSelect', [
  [
    'path',
    {
      d: 'M19.9351 21.12C18.8351 18.18 18.2951 15.09 18.2951 12C18.2951 8.91 18.8451 5.82 19.9351 2.88C19.9851 2.77 20.0051 2.66 20.0051 2.57C20.0051 2.23 19.7651 2 19.3651 2H4.62512C4.22512 2 3.99512 2.23 3.99512 2.57C3.99512 2.67 4.01512 2.77 4.05512 2.88C5.16512 5.82 5.70512 8.91 5.70512 12C5.70512 15.09 5.15512 18.18 4.06512 21.12C4.01512 21.23 3.99512 21.34 3.99512 21.43C3.99512 21.76 4.22512 22 4.62512 22H19.3751C19.7651 22 20.0051 21.76 20.0051 21.43C20.0051 21.33 19.9851 21.23 19.9351 21.12Z',
      key: '3p04w5',
    },
  ],
]);

export default PanoramaVerticalSelect;
